// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"198":"2c821cc6","502":"6068a0db","580":"f1b826f8","739":"9c81909f"}[chunkId] + ".chunk.css";
};